// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderNew_container__1bfhq","brandmarkLink":"HeaderNew_brandmarkLink__vaWEM","arrowContainer":"HeaderNew_arrowContainer__1RiQQ","close":"HeaderNew_close__2Kwsc"};